import React, { useMemo } from 'react';
import { getCountryFlag } from '@/pages/home/_config/countries';
import {
  getCountryNameByCountryCode,
  resolveCountryMarketCode,
  mergeRegionsCountriesList,
} from '@/pages/intelligence/utils/commonUtils';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { useIntl, getLocale } from 'umi';
interface CountriesShareColumnType {
  countriesShareType?: string;
  localizedCountryName?: Function; // 自定义翻译国家函数
  regionsCountries?: any[];
  showOthersCountryFlag?: boolean;
}

export const CountriesShareColumn = (params: CountriesShareColumnType) => {
  const {
    countriesShareType = 'market',
    localizedCountryName,
    regionsCountries: regionsCountriesProp,
    showOthersCountryFlag = false,
  } = params;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { regionOptions: rpdRegionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.rpd,
  });

  const effectiveRegionsCountries = useMemo(
    () => mergeRegionsCountriesList([regionsCountriesProp, rpdRegionOptions]),
    [regionsCountriesProp, rpdRegionOptions],
  );

  const getDbiCountryFlag = (market: string) => {
    if (['total'].includes(market)) {
      return getDataSourceIcon(market);
    }
    return getCountryFlag(market);
  };

  const shouldShowCountryImg = (market: string) => {
    const isGlobalOrGlobalWoChina = ['global', 'global_wo_china'].includes(market);
    return (
      isGlobalOrGlobalWoChina ||
      (market !== 'Others' && countriesShareType === 'market') ||
      (market === 'Others' && showOthersCountryFlag)
    );
  };

  const getLocalizedCountryName = (options: any) => {
    const { cvm, localizedFunction, regionsCountries, countriesShareType } = options;
    const marketLower = typeof cvm?.market === 'string' ? cvm.market.toLowerCase() : undefined;
    const allowedMarkets = ['global', 'global_wo_china', 'total', 'others'];

    if (allowedMarkets.includes(marketLower)) {
      return formatMessage({
        id: `dbi_${marketLower}`,
        defaultMessage: cvm?.market,
      });
    }

    if (localizedFunction instanceof Function) {
      return localizedFunction(cvm, locale, regionsCountries, countriesShareType);
    }

    return getCountryNameByCountryCode(regionsCountries, cvm?.market, countriesShareType);
  };

  return {
    key: 'app_id',
    header: formatMessage({ id: `dbi_countries` }),
    width: 200,
    align: 'left',
    render: (cvm: any) => {
      const market = cvm?.market;
      const resolvedMarket = resolveCountryMarketCode(
        market,
        effectiveRegionsCountries,
      );
      const showCountryImg = shouldShowCountryImg(market);
      const countryName = getLocalizedCountryName({
        cvm: { ...cvm, market: resolvedMarket },
        localizedFunction: localizedCountryName,
        regionsCountries: effectiveRegionsCountries,
        countriesShareType,
      });

      return (
        <div className="table-countries">
          {showCountryImg && (
            <img
              src={getDbiCountryFlag(resolvedMarket)}
              className="countries-img"
            />
          )}
          <span className="countries-text">{countryName}</span>
        </div>
      );
    },
  };
};
